import { render, staticRenderFns } from "./DealerRegistrationSuccess.vue?vue&type=template&id=a3e33c56&scoped=true"
import script from "./DealerRegistrationSuccess.vue?vue&type=script&lang=js"
export * from "./DealerRegistrationSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e33c56",
  null
  
)

export default component.exports